<template>
  <LayoutDefault>
    <UnlockPostWithTokensModal v-if="openModalUnlockPost" @cancel="openModalUnlockPost = !openModalUnlockPost" :model="unlockPostModel" :post="unlockPostPost"/>
    <div
        v-if="model /*&& model.webstar*/"
        id="webstar_profile"
        class="container"
    >
      <div
          class="banner"
          :style="{backgroundImage: `url('${model.public_banner_image_path}')`}"
      >
      </div>
      <div class="data">
        <div class="profile">
          <router-link
            :to="{name: 'model.username', params: {username: '@' + model.username}}"
          >
            <div class="pic"
                  :style="{backgroundImage: `url('${model.public_profile_image_path}')`}"
            ></div>
          </router-link>
          <div class="name">
            <router-link
                :to="{name: 'model.username', params: {username: '@' + model.username}}"
            >
              {{model.name}}
            </router-link>
            <div
                v-if="model.username"
                class="username"
            >
              <router-link
                :to="{name: 'model.username', params: {username: '@' + model.username}}"
              >
                @{{ model.username }}
              </router-link>
              <img
                v-if="model.verified"
                class="badge-verified"
                src="/img/verified.png"
                alt="verified"
                title="verified"
              >
            </div>
          </div>
        </div>
        <div class="right-container">
          <div class="subscribe-actions" style="display: flex; flex-direction: column;">
            <div
              v-if="model.subscription_plans"
            >
              <FollowModelButton
                  v-if="model.webstar && !model.following"
                  class="btn_follow"
                  v-for="subscription_plan in model.subscription_plans.data"
                  :key="subscription_plan.id"
                  :subscription_plan="subscription_plan"
              />
            </div>
            <ButtonChatWithModel
              class="btn_follow"
              :model="model"
              v-if="chatButtonEnabled"
            />
          </div>
          <div class="about-me">
            {{ model.about_me }}
            
            <div
              v-for="(social, index ) in model.public_socials"
              :key="index"
              class="social-buttons"
            >
              <a :href="social.url" target="_blank">
                <img :src="`/img/socials/${social.site}.png`" :alt="social.site">
                @{{social.user}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
        id="model_profile"
        class="container"
    >
      <template v-if="!loadingModel && !errorModel">
        <div class="model-wrapper">
          <h3
              v-if="true/*!model.webstar*/"
              class="title">
              {{model.name}}
          </h3>

          <div class="video-wrapper"></div>

          <div class="model-video-list">
            <div>
                <!-- <template v-if="errorPost">
                    <div class="error" v-if="errorPost">
                        <p>{{$t('error')}}</p>
                        <button type="button" @click="loadFirstResources">
                            {{$t('retry')}}
                        </button>
                    </div>
                </template> -->

                <div v-show="!errorPost" class="carousel-wrapper">
                    <div class="carousel" ref="carousel">
                        <template v-if="loadingPost" >
                          <div class="slide">
                            <MovieBlockedContainer :placeholder="true"/>
                          </div>
                        </template>

                        <template v-else-if="!post || !Object.keys(post).length">
                          <p v-if="!post || !Object.keys(post).length">{{$t('noRecordsFound')}}</p>
                        </template>

                        <template v-else>
                          <div class="slideVertical">
                            <PostSorter :element="post" :model="model"/>
                            <hr/>
                          </div>
                          <p v-if="!post">{{$t('noRecords')}}</p>
                        </template>
                    </div>
                </div>
            </div>
            
          </div>
        </div>
      </template>

      <template v-else>
        <div v-if="loadingModel" class="loading-model">
          <Spinner></Spinner>
        </div>
        <div v-if="errorModel" class="error-model">
            {{$t('error')}}
        </div>
      </template>
    </div>
  </LayoutDefault>
</template>

<script>
import Spinner from "../../components/Spinner";
import resources from "../../resources";
import ResourceScroller from "../../components/V2/ResourceScroller";
import MovieBlockedContainer from "../../components/Post/Movie/BlockedContainer.vue";
import EventBus from "../../eventbus";
import LayoutDefault from "../../layouts/LayoutDefault";
import FollowModelButton from "../../components/CallToAction/ButtonFollowModel";
import ButtonChatWithModel from "../../components/CallToAction/ButtonChatWithModel";
import PostSorter from "../../components/Post/Sorter.vue";
import UnlockPostWithTokensModal from "../../components/UnlockPostWithTokensModal";

export default {
  components: {
    PostSorter,
    LayoutDefault,
    Spinner,
    ResourceScroller,
    MovieBlockedContainer,
    FollowModelButton,
    ButtonChatWithModel,
    UnlockPostWithTokensModal,
  },
  data() {
    return {
      model: null,
      loadingModel: true,
      loadingChat: true,
      errorModel: false,
      languageChanged: false,
      openModalUnlockPost: false,
      unlockPostModel: {},
      unlockPostPost: {},
      post: {},
      errorPost: false,
      loadingPost: true,
    };
  },
  methods: {
    loadPost(username, post) {
      this.loadingModel = true;
      this.errorModel = false;
      this.model = null;

      const data = {
        id: username,
        username
      };

      if (this.$i18n && this.$i18n.locale) {
        data.lang = this.$i18n.locale;
      }

      resources.models
        .get(data)
        .then((response) => {
          this.loadingChat = true;
          this.loadingModel = false;
          this.model = response.data.data;

          if (response.data.data.length === 0) {
            //If the language didn't change, and the model doesnt exist redirect to 404.
            if (this.languageChanged == false)
              this.$router.push({ name: "error404" });
            else this.languageChanged = false;
          } else if (this.model.id) {
            resources.chatModel
              .storeAt({ id: this.model.id })
              .then((response) => {
                this.loadingChat = false;
                this.model.chat = response.data.data;
              })
              .catch((error) => {
                this.loadingChat = true;
              });

            resources.models
              .getPost({ postID: post, modelID: this.model.id })
              .then((response) => {
                console.log(response.status);
                this.post = response.data.data;
                this.loadingPost = false;
              })
              .catch((error) => {
                this.loadingPost = false;
                this.errorPost = error.status !== 404 && error.body === [];
              });
          }
        })
        .catch((err) => {
          this.loadingModel = false;
          this.errorModel = true;
        });
    },
  },
  mounted() {
    const { username, post } = this.$route.params;
    this.loadPost(username, post);

    EventBus.$on("languageChanged", () => {
      this.languageChanged = true;
      this.loadPost(username, post);
    });

    EventBus.$on("openedUnlockPostWithTokens", (post, model) => {
      this.unlockPostPost = post;
      this.unlockPostModel = model;
      this.openModalUnlockPost = true;
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.loadPost(to.params.id, to.params.post);

    next();
  },
  computed: {
    similarModelsScroller() {
      if (this.loadingModel || this.errorModel) {
        return null;
      }

      return {
        resource: resources.models,
        defaultParams: {
          include: [],
          models: {
            id: this.model.id,
          },
        },
      };
    },
    modelMoviesScroller() {
      if (this.loadingModel || this.errorModel) {
        return null;
      }

      return {
        resource: resources.posts,
        defaultParams: {
          include: [],
          models: {
            id: this.model.id,
          },
        },
      };
    },
    subscriptionPlanPremium() {
      if (
        this.loadingModel ||
        this.errorModel ||
        !this.model.subscription_plans
      ) {
        return null;
      }

      return this.model.subscription_plans.data.find(
        (subscription_plan) => subscription_plan.premium
      );
    },
    chatButtonEnabled(){
      return !! (process.env.VUE_APP_CHAT_ENABLED && process.env.VUE_APP_CHAT_ENABLED === 'true');
    }
  },
};
</script>

<style scoped lang="scss">
@import "../../styles/variables";

#model_profile {
  background-color: var(--pallete_clear_color);
  padding: 30px 7px;

  .slideVertical {
    width: 600px;
    max-width: 90%;
    min-height: 300px;
    margin: 5px 0;
    @media (max-width: 720px) {
      max-width: 100%;
    }

    hr {
      border-color: #dcdcdc;
    }
  }

  .model-wrapper {
    display: block;
    margin: auto;
    max-width: 100%;

    .about {
      display: block;
      margin: auto;
      width: 70%;

      @media (max-width: 768px) {
        width: 100%;
      }
    }

    & > .title {
      border-top: 10px solid var(--pallete_main_color);
      color: #000000;
      padding: 0.33em;
      font-size: 1.4em;
      text-align: left;
      margin: 0;
      text-transform: uppercase;
      display: inline-block;
    }

    .image {
      /*
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
            background-color: lightgrey;
        */

      min-height: 250px;
      max-width: 100%;
      height: auto;

      img {
        width: auto;
        display: block;
        margin: auto;
        height: auto;
        max-height: 100vh;
      }
    }

    .title {
      text-align: left;
      margin: 0;
      margin-bottom: 10px;
    }

    .banner {
      display: block;
      margin: auto;
      width: auto;
      max-height: 500px;
    }

    .details {
      .title {
        font-size: 40px;
        text-transform: uppercase;
        color: var(--pallete_main_color);
        margin: 0 0 20px 0;
      }
    }
  }

  .model-video-list {
    margin-bottom: 75px;
    margin-top: 35px;

    .title {
      font-size: 1.4em;
      text-align: left;
      margin: 5px;
      margin-bottom: 15px;
      text-transform: uppercase;
    }
  }

  .related-models {
    .title {
      font-size: 1.4em;
      text-align: left;
      margin: 5px;
      margin-bottom: 15px;
      text-transform: uppercase;
    }
  }
}
.carousel-wrapper {
  position: relative;

  @media (min-width: 770px) and (max-width: 1440px) {
  }

  &:focus {
    .arrow {
      .draw {
        opacity: 1;
      }
    }
  }

  .arrow {
    position: absolute;
    height: 100%;
    display: flex;

    @media (max-width: 770px) {
      display: none;
    }

    .draw {
      transition: opacity 0.5s ease;
      opacity: 1;
      cursor: pointer;
      align-self: center;
      height: 0;
      width: 0;
      border: 50px solid transparent;
      user-select: none;
      z-index: 10;
    }

    &.disabled {
      &.left {
        .draw {
          //border-right: 25px solid rgba(125, 125, 125, 1) !important;
          opacity: 0.35;
        }
      }

      &.right {
        .draw {
          //border-left: 25px solid rgba(125, 125, 125, 1) !important;
          opacity: 0.35;
        }
      }
    }

    &.left {
      left: -50px;
      width: 0;

      @media (max-width: 1440px) {
        left: 0px;

        .draw {
          border-right-color: var(--pallete_main_color) !important;
        }
      }

      .draw {
        border-left: 0;
        border-right: 25px solid rgba(125, 125, 125, 1);
      }
    }

    &.right {
      right: -25px;
      width: 0;

      @media (max-width: 1440px) {
        right: 25px;

        .draw {
          border-left-color: var(--pallete_main_color) !important;
        }
      }

      .draw {
        border-right: 0;
        border-left: 25px solid rgba(125, 125, 125, 1);
      }
    }
  }

  .carousel {
    scroll-behavior: smooth;

    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    overflow-scrolling: touch;
    justify-content: center;

    -ms-overflow-style: none; /* IE 10+ */
    overflow: -moz-scrollbars-none; /* should hide scroll bar */

    &::-webkit-scrollbar {
      display: none; /*  might be enough */
      background: transparent;
      visibility: hidden;
      width: 0;
    }

    .slide {
      width: auto;
      flex: 0;

      &:hover {
        //background-color: #ff0000;
      }
    }
  }
}

.error {
  text-align: center;
}

.loading {
  text-align: center;
}
</style>
<style lang="scss">
#model_profile {
  .related-models {
    .model {
      width: 250px;

      .img {
        height: 420px;
      }
    }
  }

  // tamaño del video
  .model-video-list {
  }
}
</style>

<style scoped lang="scss">
@import "../../styles/variables.scss";

#webstar_profile {
  .banner {
    position: relative;
    height: 350px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

    @media (max-width: 768px) {
      height: 200px;
    }
  }

  .data {
    position: relative;
    height: 150px;
    background-color: var(--pallete_clear_color);
    @media (max-width: 768px) {
      height: unset;
    }

    .profile {
      width: 40%;
      min-height: 250px;
      position: absolute;
      left: 5px;
      top: -100px;
      @media (max-width: 768px) {
        position: relative;
        width: 99%;
        min-height: unset;
      }
      .pic {
        width: 200px;
        height: 200px;
        margin: 0 auto;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        background-color: #ffffff;
        border-radius: 50%;
        border: 3px solid #ffffff;

        @media (max-width: 768px) {
          width: 150px;
          height: 150px;
        }
      }
      .name {
        min-height: 50px;
        font-size: 1.5em;
        font-weight: bold;
        text-align: center;
        text-transform: uppercase;
        margin: 10px;
        @media (max-width: 768px) {
          min-height: unset;
        }

        .username {
          display: flex;
          justify-content: center;
          font-size: 0.6em;
          text-transform: initial;
          margin: 3px;
          color: #7986cb;
          &:hover {
            color: #5768c4;
          }

          img {
            &.badge-verified {
              width: 20px;
              margin-left: 5px;
            }
          }
        }
      }
    }

    .right-container {
      position: absolute;
      display: flex;
      right: 10px;

      top: 10px;
      width: 65%;
      flex-direction: row-reverse;
      justify-content: space-between;
      align-items: flex-start;

      .btn_follow {
      }

      .about-me {
        margin-right: 20px;
        @media (max-width: 768px) {
          margin: 10px auto 25px auto;
        }

        .social-buttons {
          margin: 10px 0;

          a {
            display: flex;
            align-items: center;
            font-size: 0.8em;

            @media (max-width: 768px) {
              justify-content: center;
            }

            img {
              width: 20px;
              margin-right: 5px;
            }
          }
        }
      }

      @media (max-width: 768px) {
        position: relative;
        width: 95%;
        text-align: center;
        right: 0;
        left: 0;
        top: unset;
        bottom: 0;
        margin: 0 auto;
        flex-direction: column-reverse;
        align-items: center;
        margin-top: -100px;
      }
    }
  }
}
</style>
